import React from 'react';
import AboutSection from './AboutSection.jsx';
import aboutDescriptionDB from '../aboutDescriptionDB/aboutDescriptionDB.js';
import '../../img/bi/delivery.jpg';

const About = () =>
	<section className='about'>
		{
			aboutDescriptionDB.map((i,n) =>{
				return <AboutSection key={n} showAnime={n==0?true:false} data={i}/>
			})
		}
	</section>

export default About;